import { atom, useAtom } from "jotai";

import { MarketOrder } from "#/types/orders";

export const perpMarketOrderTypeAtom = atom<MarketOrder>(MarketOrder.IOC);

export const usePerpMarketOrderType = () => {
  const [perpMarketOrderType, setPerpMarketOrderType] = useAtom(
    perpMarketOrderTypeAtom,
  );

  return {
    perpMarketOrderType,
    setPerpMarketOrderType,
  };
};
